module.exports = __webpack_public_path__ + "static/colorado-springs-abbc2144e9b749566b4b183c033ed432.png";